module.exports = __webpack_public_path__ + "2ff60ae5d815acc56d1501f4fa196b83.png";